import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const mealMenu = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getMealMenus(){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus`)
  },
  getMealsFromMenu(id){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/${id}`)
  },
  getMealsName(){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meal-names`)
  },
  getDishesName(id){
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals/${id}/dishes`)
  },
  deleteMealMenu(id){
    return Axios.delete(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/${id}`)
  },
  addDishes(meal) {
    return Axios.post(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus`, meal)
  },
  editDishes(meal) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/${meal.id}`, meal)
  },
  getMealMenuFile() {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/files`, headers)
  },
  getMealMenuTemplateFile() {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/files/template`, headers)
  },
  getMealMenuFileErrors (fileId) {
    let headers = {responseType: 'arraybuffer'}
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/errors/${fileId}`, headers)
  },
  importMealMenuFile (file) {
    let fileForm = new FormData()
    fileForm.append('file', file)
    return Axios.post(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/menus/files`, fileForm)
  },
}

export default mealMenu
